import React from "react"

import { ConnectorDialog } from "~/ui-rtk/components/features/connectors"

import { connectorIcons } from "~/ui-rtk/shared/constants/image-paths.contants"
import { Button } from "~/ui-rtk/components/ui/controls"
import MetaPermissionsNote from "../shared/MetaPermissionsNote"

type FacebookMarketingFormProps = {
  isOpen: boolean
  onClose: () => void
  onContinue: () => void
}

const FacebookMarketingForm: React.FC<FacebookMarketingFormProps> = ({
  isOpen,
  onClose,
  onContinue,
}) => (
  <ConnectorDialog
    imgSrc={connectorIcons.facebookAds}
    alt="Facebook Marketing Logo"
    title="Connection to Facebook Marketing"
    isOpen={isOpen}
    onClose={onClose}
  >
    <MetaPermissionsNote />

    <Button
      variant={{ variant: "solid", color: "white" }}
      onClick={onContinue}
      className="w-full"
    >
      Continue
    </Button>
  </ConnectorDialog>
)

export default FacebookMarketingForm
